import React from 'react'
import AbstractAdminVer from '../utils/AbstractAdminVer'

function VerAcopios() {
  return (
    <div className="section h-full mx-2 my-5 md:w-10/12">
      <AbstractAdminVer
        objectName={{
          plural: "Acopios",
          singular: "acopio",
          formal: "acopios",
          informal:"acopio"
        }}
        itemName={"nombre"}
        query={"acopiosempresa"}
        configPath={"utils/configFiles/config.json"}
      ></AbstractAdminVer>{" "}
    </div>
  )
}

export default VerAcopios